import { Icon } from 'semantic-ui-react';
import React from 'react';
import { tl } from '../../services/i18nService';
import * as classes from './HideButton.scss';

interface HideButtonProps {
    handleClick: () => void;
    inverted?: boolean;
}

const HideButton = React.memo(({ handleClick, inverted }: HideButtonProps) => {
    const text = tl('common.sidebar.header.hide');
    return (
        <button
            className={`${classes.hideButton}${inverted ? ' inverted' : ''}`}
            onClick={handleClick}
            type="button"
        >
            <Icon name="chevron left" size="small" />
            <span className={classes.hideButtonText}>
                {text}
            </span>
        </button>
    );
});

export default HideButton;
